import { render } from "./ModuleManuelleAntragslistePreview.pug?vue&type=template&id=11dd981c&lang=pug"
import script from "./ModuleManuelleAntragslistePreview.js?vue&type=script&lang=js"
export * from "./ModuleManuelleAntragslistePreview.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__